import * as React from 'react'
import { Dialog, DialogContent } from '@mui/material'
import TextField from '@mui/material/TextField'
import Autocomplete from '@mui/material/Autocomplete'
import { useTranslation } from 'react-i18next'
import { useEventStore } from 'Store/eventStore'
import SearchIcon from '@mui/icons-material/Search'
import useNavigateCustom from 'Components/Navigation'

interface Props {}
const Search: React.FC<Props> = () => {
      const { t } = useTranslation()
      const [isOpen, setIsOpen] = React.useState(false)
      const { navigate } = useNavigateCustom()
      const getSubscriptions = useEventStore((state) => state.getSubscriptions)
      const events = useEventStore((state) => state.events)

      const handleChange = (event, value) => {
            if (value) {
                  navigate(`/${value.unique_id}`)
            }
      }

      React.useEffect(() => {
            if (events.length === 0 && isOpen) {
                  getSubscriptions()
            }
      }, [isOpen])
      return (
            <>
                  <SearchIcon
                        sx={{
                              width: 28,
                              height: 28,
                              marginLeft: 'auto',
                        }}
                        onClick={() => setIsOpen(true)}
                  />

                  <Dialog
                        open={isOpen}
                        fullWidth
                        onClose={() => setIsOpen(false)}
                        sx={{
                              overflow: 'visible',
                              alignSelf: 'flex-start',
                              margin: 0,
                              width: '100%',
                              '.MuiPaper-root': {
                                    margin: 0,
                                    width: '100%',
                                    overflow: 'visible',
                              },
                        }}
                  >
                        <DialogContent sx={{ p: 0 }}>
                              <Autocomplete
                                    disablePortal
                                    options={events}
                                    getOptionLabel={(option) => option.title}
                                    getOptionKey={(option) => option.unique_id}
                                    onChange={handleChange}
                                    renderInput={(params) => (
                                          <TextField {...params} label={t('search_search')} />
                                    )}
                              />
                        </DialogContent>
                  </Dialog>
            </>
      )
}
export default Search
